import { Controller } from "@hotwired/stimulus"
import Uppy from "@uppy/core"
import FileInput from "@uppy/file-input"
import XHRUpload from "@uppy/xhr-upload"
import ProgressBar from "@uppy/progress-bar"
import imagesLoaded from "imagesloaded"

const MAX_FILE_SIZE = 5242880

export default class extends Controller {
  static targets = [
    "progressBar",
    "imageAction",
    "imageFilename",
    "listingAction",
    "listingTitle",
    "errorMessage",
    "fileInput",
    "imageInput",
    "listingInput",
    "submitButton",
    "imageUploadButton",
  ]

  static values = {
    conversationId: Number,
  }

  connect() {
    this.adjustForMobile()
    this.scrollConversation()
  }

  setupUppy() {
    this.uppy = new Uppy()
      .use(FileInput)
      .use(XHRUpload, { endpoint: "/api/upload" })
      .use(ProgressBar, { target: this.progressBarTarget })

    this.uppy.on("upload", () => {
      this.imageUploadButtonTarget.disabled = true
    })

    this.uppy.on("upload-success", (file, response) => {
      this.fileId = file.id
      this.imageInputTarget.value = JSON.stringify(response.body)
      this.imageActionTarget.style.display = "block"
      this.imageFilenameTarget.textContent = file.name
      this.submitButtonTarget.disabled = false
      this.imageUploadButtonTarget.disabled = false
    })

    this.uppy.on("upload-error", () => {
      this.submitButtonTarget.disabled = false
      this.imageUploadButtonTarget.disabled = false
      this.imageInputTarget.value = null
      this.fileInputTarget.value = null
      this.showErrorMessage("Image upload error. Please try again.")
    })
  }

  adjustForMobile() {
    const small = window.matchMedia("(max-width: 992px)")
    if (small.matches) {
      document.getElementById("conversation-policy")?.classList.remove("in")
    }
  }

  scrollConversation() {
    const conversation = document.getElementById("conversation")
    if (conversation) {
      imagesLoaded(conversation, () => {
        conversation.scrollTop = conversation.scrollHeight
      })
    }
  }

  handleFileChange(event) {
    this.setupUppy()

    const file = event.target.files[0]
    this.submitButtonTarget.disabled = true
    this.listingActionTarget.style.display = "none"
    this.listingInputTarget.value = ""
    this.hideErrorMessage()

    if (file) {
      if (file.size >= MAX_FILE_SIZE) {
        this.showErrorMessage("Image is too large (max is 5 Mb)")
        this.submitButtonTarget.disabled = false
      } else {
        try {
          this.uppy.addFile({
            source: "file input",
            data: file,
            name: file.name,
            type: file.type,
          })
          this.uppy.upload()
        } catch (err) {
          this.submitButtonTarget.disabled = false
        }
      }
    } else {
      this.imageActionTarget.style.display = "none"
      this.progressBarTarget.querySelector(".uppy-ProgressBar-inner").style.width = "0"
    }
  }

  attachListing({ title, id }) {
    this.imageActionTarget.style.display = "none"
    this.listingActionTarget.style.display = "block"
    this.listingTitleTarget.textContent = title
    this.listingInputTarget.value = id
    this.fileInputTarget.value = null
    this.imageInputTarget.value = null
  }

  triggerFileInput() {
    if (this.submitButtonTarget.disabled) return

    this.fileInputTarget.click()
    this.hideErrorMessage()
  }

  removeImage(event) {
    event.preventDefault()
    this.fileInputTarget.value = null
    this.uppy.removeFile(this.fileId)
    this.imageInputTarget.value = null
    this.imageActionTarget.style.display = "none"
    this.progressBarTarget.querySelector(".uppy-ProgressBar-inner").style.width = "0"
  }

  openListingModal() {
    $("#listing-search-modal").modal("show")
    this.hideErrorMessage()
  }

  removeListing(event) {
    event.preventDefault()
    this.listingActionTarget.style.display = "none"
    this.listingInputTarget.value = null
  }

  showErrorMessage(message) {
    this.errorMessageTarget.textContent = message
    this.errorMessageTarget.style.display = "block"
  }

  hideErrorMessage() {
    this.errorMessageTarget.style.display = "none"
  }
}
